import Api from '../../api/api.js';
import PieChart from '../charts/pie-chart.js';
import ColumnChart from '../charts/column-chart.js';
import TableChart from '../charts/table-chart.js';
import Modal from '../../alerts/modal.js';


export default class AbstractBuilder 
{

	constructor(params) 
	{
		// if (!chart instanceof AbstractParams) {
		// 	return;
		// }

		this.$chart = null;
		this.chart  = null;
		this.params = params;
	}


	setChart(chart) 
	{
		// if (!chart instanceof AbstractChart) {
		// 	return;
		// }
		
		this.chart = chart;

		return this;
	}


	getChart() 
	{
		return this.chart;
	}


	buildDomContainer(classname, id) 
	{
		return $('<div/>')
			.addClass(classname)
			.addClass('pull-left')
			.attr('id', id);
	}


	buildDomAlert(type, contents) 
	{
		return $('<div/>')
			.addClass('alert')
			.addClass('alert-' + alert)
			.html(contents);
	}


	buildDomAlerts(alerts) 
	{
		if (!alerts || Object.keys(alerts).length == 0) {
			return '';
		}
		let $alerts = $('<section/>').addClass(this.chart_class);

		for (alert in alerts) {

			if (alerts[alert]) {

				$alerts.append(this.buildDomAlert(alert, '<b>' + alert.toUpperCase() + '</b>: ' + alerts[alert]));
			
			}

		}
		return $alerts;
	}


	getDomElement() 
	{
		return this.$chart;
	}


	fetchDataFromServer(chart, filters) 
	{
		const d = $.Deferred();

		(new Api)
			
			.getRequest('/admin/analytics/data', {chart, filters})
			
			.then((data) => {
			
			 	d.resolve(data.data);
			
			});

		return d.promise();
	}


	newChart(params) 
	{
		switch(params.type) {
			case 'column':
				return new ColumnChart(params);
			break;
			case 'pie':
				return new PieChart(params);
			break;
			case 'table':
				return new TableChart(params);
			break;
			default:
				(new Modal).error('Error', 'Unrecognised chart type', 'error');
			return;
		};
	}


	processServerData(server_data) 
	{
		this.params._sdata = server_data;

		this.params.rows = server_data.rows;
		
		this.params.cols = server_data.cols;
	};


	appendDomContainer() 
	{
		this.$chart = this.buildDomContainer(this.chart_class, this.params.id);

		$('#ajax_content').append(this.getDomElement());
	}


	noResults()
	{
		$('#ajax_content').html('<div class="alert alert-warning">No results found</div>');
	}


	/**
	 * Some chart data is only compatible with specific chart types
	 * eg. Table charts if lots of rows and columns - this data will not work with 'pie' and 'column' charts
	 * @param object - server_data
	 * @return promise
	 */
	updateChartTypesFilter(current_type, allowed_types) 
	{
		const d = $.Deferred();

		let options = ''; 

		for (let i=0; i<allowed_types.length; i++) {
		
			const selected = (current_type === allowed_types[i]) ? 'selected' : '';
		
			const type = allowed_types[i].charAt(0).toUpperCase() + allowed_types[i].slice(1);
		
			options += "<option " + selected + " value='" + allowed_types[i] + "'>" + type + " Chart</option>";
		
		}
		
		if (options.length) {

			$('.analytics-filters').find("select[name=type]").html(options);
			
			d.resolve();
		
		} else {
			
			$('.analytics-filters').find("select[name=type]").html('');
			
			d.resolve();
		
		}
		return d.promise();
	}


	/**
	 * Build a "chart"
	 * @param string - chart_name - eg. 'average_theoretical'
	 * @return promise
	 */
	build(chart_name) 
	{
		this.appendDomContainer();
		
		const d = $.Deferred();

		this.fetchDataFromServer(chart_name, [])

			.then((data) => {
				
				this.updateChartTypesFilter(this.params.type, data.allowed_types)

					.then(()=> {

						if (this.params.type && data.allowed_types.indexOf(this.params.type) == -1) {

							window.Chart_manager.refresh();
						
							return;
						}
						
						this.processServerData(data);

						const chart = this.newChart(this.params);

						if (chart) {

							// Show alerts
							if (data.hasOwnProperty('alerts')) {

						 		$('#' + this.params.id).before(this.buildDomAlerts(data.alerts));
							
							}

							// Show title
							if (data.hasOwnProperty('title')) {
							
								const title = $('<h2/>').addClass(this.chart_class).html(data.title);
								
								$('#' + this.params.id).before(title);
							
							} 
							
							if (data['rows'].length == 0) {

								this.noResults();

								d.resolve();

							} else {

								this.setChart(chart);
								
								this.draw();
								
								d.resolve();

							}

						}
					});

			});
		return d.promise();
	}


	draw() 
	{
		const chart = this.getChart();
		
		if (chart) {
			
			this.chart.draw();
		
		}
	}


}